import React from 'react'
import { reduxForm } from 'redux-form'
import { generateValidation } from 'redux-form-validation'
import BaseModal from '../base-modal'
import {
  ModalForm,
  ModalFormRow,
  ModalFormBlock,
  InlineCheckbox
} from '../modal-form/modal-form'
import ModalScrollTop from '../helpers/ModalScrollTop'

import at from 'lodash/at'
import cx from 'classnames'

import AreaSelectorContainer from '../../containers/forms/area-selector-container'
import ServicesSelectorContainer from '../../containers/forms/services-selector-container'
import ServicingLabelSelectorContainer from '../../containers/servicing-labels/servicing-label-selector-container'
import TechnicianSelectorContainer from '../../containers/technicians/technician-selector-container'

const constraints = {
  'width': '706px',
  'minWidth': '706px'
}

const validations = {
  areaIds: {
    required: true,
    minLength: 1
  },
  highPriority: {},
  requireImages: {},
  serviceIds: {
    required: true,
    minLength: 1
  },
  servicingLabelIds: {},
  assigneeId: {},
  comment: {},
}

const AreaCreate = ({
  fields: {
    areaIds,
    highPriority,
    requireImages,
    serviceIds,
    servicingLabelIds,
    assigneeId,
    comment,
  },
  workOrder,
  location,
  areasWithIssuesText,
  submitting,
  handleSubmit,
  handleClose
}) => {
  const areaIdsValid = areaIds.error
  const serviceIdsValid = serviceIds.error
  const validations = {
    areaId: {
      valid: areaIds.error,
      error: 'Please select at least one area.'
    },
    serviceId: {
      valid: serviceIds.error,
      error: 'Please select at least one service.'
    },
  }
  const invalidFieldKeys = Object.keys(validations).filter(key => validations[key].valid)
  const invalidFields = at(validations, invalidFieldKeys)
  const containsInvalidFields = invalidFields.length > 0

  return (
  <BaseModal
    onClose={handleClose}
    title='Add Area'
    constraints={constraints}
    contentClassName='areas-create-container'
  >
    <ModalForm onSubmit={handleSubmit} customClassName='areas-create-form'>
      <ModalFormRow>
        <ModalFormBlock>
          { containsInvalidFields && <p className={cx({'centered': true, 'error': true, hidden: !containsInvalidFields || submitting})}>
            {invalidFields.map(field => (<p>• {field.error}</p>))}
            <ModalScrollTop />
          </p>}
        </ModalFormBlock>
      </ModalFormRow>
      <ModalFormRow>
        <ModalFormBlock size={2}>
          <label>Areas <span style={{ color: 'red' }}>*</span></label>
          <AreaSelectorContainer
            workOrderId={workOrder.id}
            locationId={location.id}
            {...areaIds}
          />
        </ModalFormBlock>
      </ModalFormRow>
      <ModalFormRow>
        {areasWithIssuesText && <ModalFormBlock size={2}>
          <label>Areas With Issues</label>
          <p>{areasWithIssuesText}</p>
        </ModalFormBlock>}
      </ModalFormRow>

      <ModalFormRow>
        <ModalFormBlock>
          <label>Labels</label>
          <ServicingLabelSelectorContainer locationId={location.id} {...servicingLabelIds} />
        </ModalFormBlock>
      </ModalFormRow>

      <ModalFormRow>
        <ModalFormBlock>
          <label>Assign To</label>
          <TechnicianSelectorContainer workOrderId={workOrder.id} {...assigneeId}/>
        </ModalFormBlock>
      </ModalFormRow>

      <ModalFormRow>
        <ModalFormBlock>
          <label htmlFor='comment'>Comment</label>
          <textarea placeholder='Add a comment (this comment will be pinned to area)' {...comment} />
        </ModalFormBlock>
      </ModalFormRow>

      <ModalFormRow>
        <ModalFormBlock>
          <InlineCheckbox>
            <label htmlFor='requireImages'>
              <input id='requireImages' type='checkbox' {...requireImages} />
              <span className='indicator' />
              require images
            </label>
          </InlineCheckbox>
        </ModalFormBlock>
        <ModalFormBlock>
          <InlineCheckbox>
            <label htmlFor='highPriority'>
              <input id='highPriority' type='checkbox' {...highPriority} />
              <span className='indicator' />
              high priority
            </label>
          </InlineCheckbox>
        </ModalFormBlock>
      </ModalFormRow>

      <ServicesSelectorContainer workOrderId={workOrder.id} attribute={serviceIds} />

      <ModalFormRow>
        <ModalFormBlock submitButton>
          <button type='submit'>Add</button>
        </ModalFormBlock>
      </ModalFormRow>
    </ModalForm>
  </BaseModal>
)}

export default reduxForm({
  form: 'addArea',
  ...generateValidation(validations)
})(AreaCreate)



// WEBPACK FOOTER //
// ./src/components/areas/area-create.js